import { StrictOmit } from '@streamloots/streamloots-types';
import type { PushInputProps } from './PushInput';
import { PushInput } from './PushInput';

export type RadioProps = StrictOmit<PushInputProps, 'type'>;

export const Radio = (props: RadioProps) => <PushInput {...props} type="radio" />;
